<template>
  <div class="gps-map-picker">
    <a-input-search
      class="mb-2"
      :placeholder="searchPlaceholder"
      v-model="searchQuery"
      @search="handleSearch"
      enter-button
    />
    <div class="map-wrapper">
      <l-map
        :zoom="zoom"
        :center="center"
        style="height: 320px; width: 100%;"
        @click="onMapClick"
      >
        <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
        <l-marker v-if="marker" :lat-lng="marker" />
      </l-map>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
})

export default {
  name: 'GpsMapPicker',
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    defaultCenter: {
      type: Object,
      default: () => ({
        lat: 48.1486,
        lng: 17.1077,
      }),
    },
    searchPlaceholder: {
      type: String,
      default:
        'Zadajte adresu, napr. „Laurinská 1, Bratislava“',
    },
    initialQuery: {
      type: String,
      default: '',
    },
  },
  data() {
    const raw = this.value && (this.value.position || this.value)
    const hasValue = raw && raw.lat && raw.lng

    const initialCenter = hasValue
      ? { lat: raw.lat, lng: raw.lng }
      : this.defaultCenter

       return {
      zoom: 13,
      center: initialCenter,
      marker: hasValue ? { lat: raw.lat, lng: raw.lng } : null,
      address: this.value && this.value.address ? this.value.address : '',
      searchQuery: this.initialQuery || '',
      tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      tileAttribution: '&copy; OpenStreetMap contributors',
    }
  },
 watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) return

        const pos = val.position || val
        if (!pos || !pos.lat || !pos.lng) return

        // nastav marker + centrovanie mapy
        this.marker = { lat: pos.lat, lng: pos.lng }
        this.center = { lat: pos.lat, lng: pos.lng }

        // prípadne aktualizuj adresu
        if (val.address) {
          this.address = val.address
        }
      },
    },
  },

mounted() {
   if (!this.marker && this.initialQuery) {
      this.searchQuery = this.initialQuery
      this.handleSearch()
    }
},
  methods: {
    onMapClick(e) {
      const { lat, lng } = e.latlng
      this.marker = { lat, lng }
      this.center = { lat, lng }
      this.reverseGeocode(lat, lng)
    },

      async handleSearch() {
      if (!this.searchQuery) return

      try {
        const res = await fetch(
          'https://nominatim.openstreetmap.org/search?' +
            'format=json&addressdetails=1&limit=1&q=' +
            encodeURIComponent(this.searchQuery),
        )
        const data = await res.json()
        if (Array.isArray(data) && data.length) {
          const item = data[0]
          const lat = parseFloat(item.lat)
          const lng = parseFloat(item.lon)

          this.marker = { lat, lng }
          this.center = { lat, lng }
          this.address = item.display_name || ''

          this.emitChange()
        }
      } catch (err) {
        console.error('Nominatim search error', err)
      }
    },

    async reverseGeocode(lat, lng) {
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
        )
        const data = await res.json()
        this.address = data && data.display_name ? data.display_name : ''
      } catch (err) {
        console.error('Nominatim reverse error', err)
        this.address = ''
      } finally {
        this.emitChange()
      }
    },

    emitChange() {
      if (!this.marker) return

      const payload = {
        // necháme tvar s position, aby to sedelo s tým, čo už máš uložené
        position: {
          lat: this.marker.lat,
          lng: this.marker.lng,
        },
        address: this.address || null,
      }

      this.$emit('change', payload)
      this.$emit('input', payload)
    },
  },
}
</script>

<style scoped>
.gps-map-picker .map-wrapper {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow: hidden;
}
</style>
